import {DatetimeHelper} from "./DatetimeHelper";

export class BudgetHelper {
    static BudgetPartialGoalTranslateToSubmit(budgetPartialGoals) {
        const dic = [];
        budgetPartialGoals.forEach(bpd => {
            dic.push({
                'date': bpd.date ? DatetimeHelper.formatDateToYYYYMMDD(bpd.date) : null,
                'value': bpd.value,
                'type': bpd.type
            });
        })
        return dic;
    }
}